import styled from '@emotion/styled';
import { IconButton } from '#components/Input/IconButton';
import { colors, spacing, typography } from '../../../../../themes';
import { hoverCheckboxStyle } from '../../styles';

export const ListWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ListItemWrapper = styled.li<{
  isSelected: boolean;
  bottomBorder?: boolean;
  nestedIndex?: number;
}>`
  ${typography.body.large};
  display: flex;
  flex-flow: row;
  gap: ${spacing.xsmall};
  padding: ${spacing.xmsmall};
  background-color: ${({ isSelected }) => (isSelected ? colors.background.grey : 'transparent')};

  ${({ bottomBorder }) => bottomBorder && `border-bottom: 1px solid ${colors.monochrome.grey20};`}

  ${({ nestedIndex }) =>
    nestedIndex && nestedIndex > 0 && `padding-left: ${12 + nestedIndex * 12}px;`}

  &:hover {
    background-color: ${colors.background.grey};
    cursor: pointer;
  }

  ${hoverCheckboxStyle}
`;

export const Divider = styled.hr`
  border: 0;
  height: 1px;
  background-color: ${colors.monochrome.grey20};
  margin: 0;
`;

export const GroupLabel = styled.div`
  ${typography.body.largeBold};
  padding-top: ${spacing.xsmall};
  padding-bottom: ${spacing.tiny};
  padding-left: ${spacing.xsmall};
  padding-right: ${spacing.xsmall};
`;

export const Description = styled.div`
  ${typography.body.medium};
  color: ${colors.primary.grey};
`;

export const SimpleListItemWrapper = styled.div<{ isSelected?: boolean; showBold?: boolean }>`
  display: flex;
  flex-flow: column;
  background-color: ${({ isSelected }) => (isSelected ? colors.background.grey : 'transparent')};
  ${({ showBold }) => showBold && `font-weight: bold;`}
`;

export const InnerListWrapper = styled.li<{ nestedIndex: number }>`
  width: 100%;
  gap: ${spacing.xsmall};
  padding: ${spacing.xmsmall};
  ${({ nestedIndex }) => nestedIndex > 0 && `padding-left: ${12 + nestedIndex * 12}px;`}
`;

export const IconWrapper = styled.div`
  display: flex;
  margin-left: auto;
  flex-shrink: 0;
  gap: ${spacing.xmsmall};
  margin-bottom: auto;
`;

export const ChevronWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
`;

export const IconButtonStyled = styled(IconButton)`
  min-width: unset;
`;
